import React from "react";
import { QuestionAndAnswer } from "../ProductDetailPageResult";
import ExpandedDescriptionQuestionsAndAnswers from "./ExpandedDescriptionQuestionsAndAnswers";
import StandardDescriptionQuestionsAndAnswers from "./StandardDescriptionQuestionsAndAnswers";
interface QuestionsAndAnswersProps {
  questionsAndAnswers: QuestionAndAnswer[];
  isExpandedDescriptionTemplate?: boolean;
}
const QuestionsAndAnswers = ({
  questionsAndAnswers,
  isExpandedDescriptionTemplate = false
}: QuestionsAndAnswersProps) => {
  return <div className="detail-section customer-qa-template bg-white" data-testid={`${isExpandedDescriptionTemplate ? "expanded-question-answer" : "question-answer"}`} data-sentry-component="QuestionsAndAnswers" data-sentry-source-file="QuestionsAndAnswers.tsx">
      {!isExpandedDescriptionTemplate && <StandardDescriptionQuestionsAndAnswers questionsAndAnswers={questionsAndAnswers} />}

      {isExpandedDescriptionTemplate && <ExpandedDescriptionQuestionsAndAnswers questionsAndAnswers={questionsAndAnswers} />}
    </div>;
};
export default QuestionsAndAnswers;